module.exports = __webpack_public_path__ + "img/naozhong.0bb21fe0.png";